import { Platform, View } from "react-native";
import { Label } from "./label";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "./select";

import { useTranslation } from "react-i18next";
import { useSafeAreaInsets } from "react-native-safe-area-context";

interface SelectRowProps {
    label: string;
    value: string;
    options: { label: string; value: string; testID?: string }[];
    onChange: (value: string) => void;
    testID?: string;
}

export function SelectRow({
    label,
    value,
    options,
    onChange,
    testID,
}: SelectRowProps) {
    const { t } = useTranslation();
    const insets = useSafeAreaInsets();
    const contentInsets = {
        top: insets.top,
        bottom: Platform.select({
            ios: insets.bottom,
            android: insets.bottom + 24,
        }),
        left: 12,
        right: 12,
    };
    const valueOption = options.find((option) => option.value === value);

    return (
        <View className="flex flex-row justify-between items-center gap-2">
            <Label className="shrink-0">{label}</Label>
            <Select
                value={valueOption}
                onValueChange={(option) => onChange(option?.value ?? "")}
            >
                <SelectTrigger testID={testID}>
                    <SelectValue placeholder={t("ui.selectOneOption")} />
                </SelectTrigger>
                <SelectContent insets={contentInsets}>
                    {options.map((option) => (
                        <SelectItem
                            key={option.value}
                            value={option.value}
                            label={option.label}
                        >
                            {option.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </View>
    );
}
